<script>
    export let title;
    export let zone;

    export let _click = () => {};
</script>

<div class='zone-text-button' on:click={_click} on:keypress={()=>{}}>
    <img src="./assets/images/zone_text_button_{zone.replace("Z", "")}.png" alt/>
    <!-- <div class="button-text" >{title}</div> -->
</div>

<style lang="scss">
    .zone-text-button{
        width: 100%;
        height: fit-content;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        &:not(:last-child){
        }

        img {
            width: 100%;
            height: auto;
            z-index: -1;
        }

        .button-text {
            position: absolute;
            color: white;
            font-size: min(2.5vw, 25px);
        }
    }
</style>